module.exports = __webpack_public_path__ + "img/watermark-long.d5770360.svg";